import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  links: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    padding: theme.spacing(0, 0.5),
    textDecoration: 'underline',
  },
}));
